<template>
  <el-dialog
    class="project-pic"
    :visible.sync="visible"
    :modal="false"
    :show-close="false"
    :fullscreen="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    @closed="$emit('closed')"
  >
    <div slot="title" style="display:flex;align-items:center;justify-content:space-between">
      <span style="font-size:20px">生成图片</span>
      <el-button icon="el-icon-close" circle type="danger" @click="closeDialog"></el-button>
    </div>
    <el-card>
      <el-row :gutter="20" type="flex" justify="center">
        <el-col :lg="{ span: 8 }" :xl="{ span: 11 }">
          <h2 style="color:#f70b0b">请不要列出具体信息（如公司名，地址等）！！</h2>
          <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="130px">
            <el-form-item label="图片标题：" prop="company">
              <el-input v-model="ruleForm.company" placeholder="e.g: 某顶级券商XXX部"></el-input>
            </el-form-item>
            <el-form-item label="岗位名称：" prop="job">
              <el-input v-model="ruleForm.job" placeholder="e.g: 机构销售"></el-input>
            </el-form-item>
            <el-form-item label="工作地点：" prop="location">
              <el-input v-model="ruleForm.location" placeholder="e.g: 北京/上海"></el-input>
            </el-form-item>
            <el-form-item label="工作年限要求：" prop="experience">
              <el-input v-model="ruleForm.experience" placeholder="e.g: 3-5年"></el-input>
            </el-form-item>
            <el-form-item label="招聘有效期：">
              <el-col :span="11" style="padding-left:0">
                <el-form-item>
                  <el-date-picker
                    v-model="ruleForm.startDate"
                    type="date"
                    placeholder="开始时间"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="2">至</el-col>
              <el-col :span="11" style="padding-right:0">
                <el-form-item>
                  <el-date-picker
                    v-model="ruleForm.endDate"
                    type="date"
                    placeholder="截止时间"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-form-item>

            <el-form-item label="职位亮点：" prop="highlight">
              <el-input
                v-model="ruleForm.highlight"
                type="textarea"
                :rows="4"
                placeholder="请输入职位亮点；几句话概括出该职位最吸引人的亮点"
                :clearable="true"
              ></el-input>
              <el-button type="text" @click="setHighigth">同步至项目</el-button>
            </el-form-item>
            <el-form-item label="职位详情：" prop="description">
              <el-input
                v-model="ruleForm.description"
                type="textarea"
                :rows="9"
                placeholder="请输入职位详情等"
                :clearable="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="选择顾问">
              <el-cascader
                v-model="value"
                :options="options"
                filterable
                :props="{ expandTrigger: 'hover' }"
                @change="handleChange"
              ></el-cascader>
            </el-form-item>
            <el-form-item label>
              <el-button type="primary" size="mini" @click="editCodeVisible = true">管理我的二维码</el-button>
            </el-form-item>
            <el-form-item label="操作">
              <el-button class="mr20 mb10" type="primary" size="mini" @click="generateImg('ruleForm')"
                >导出图片并存为项目附件</el-button
              >
              <el-button class="mr20 mb10" type="primary" size="mini" @click="previewImg('ruleForm')">预览</el-button>
              <el-button class="mr20 mb10" size="mini" @click="resetForm('ruleForm')">恢复默认</el-button>
              <el-tooltip effect="dark" content="会将当前图片数据恢复至项目原始信息，请谨慎操作" placement="top-start">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :lg="{ span: 16 }" :xl="{ span: 13 }">
          <el-card>
            <div slot="header" class="clearfix">
              <h3>图片预览：</h3>
              <el-radio-group v-model="bgType">
                <el-radio :label="'default'">默认</el-radio>
                <el-radio :label="'black&white'">黑白</el-radio>
              </el-radio-group>
            </div>
            <div v-if="bgType === 'default'" id="picDiv" class="pic-temp-cls">
              <el-row type="flex" align="middle" justify="start" style="width:100%; background:#ffffff">
                <el-col :span="24" style="margin-bottom:20px;text-align:center;">
                  <span style="font-size:20px;">成功之路 始于热爱 源于分享</span>
                </el-col>
              </el-row>
              <div v-if="ruleForm.company" class="title-cls">
                <span v-drag class="dragable-cls">{{ ruleForm.company }}</span> <br />
                <span v-drag class="dragable-cls">{{ ruleForm.job }}</span>
              </div>
              <el-row
                v-if="ruleForm.location && ruleForm.experience"
                type="flex"
                justify="center"
                style="margin-top:40px"
              >
                <span v-drag class="detail-span-cls dragable-cls"
                  >{{ ruleForm.location }} | 工作年限：{{ ruleForm.experience }}</span
                >
              </el-row>
              <el-row
                v-if="ruleForm.startDate && ruleForm.endDate"
                type="flex"
                justify="center"
                style="margin-top:20px"
              >
                <span v-drag class="detail-span-cls dragable-cls"
                  >{{ ruleForm.startDate | formatdate }} - {{ ruleForm.endDate | formatdate }}</span
                >
              </el-row>
              <el-row v-if="ruleForm.highlight" type="flex" justify="center" style="margin-top:118px">
                <div v-drag class="highlight-area-cls dragable-cls">
                  <div style="font-size: 36px;color: #000000;letter-spacing: 0.53px; padding-top: 20px;height: 70px;">
                    <span style="padding-left:80px">
                      <img src="../../statistics/images/flag.png" style="padding-right:30px" alt /> 职位亮点
                    </span>
                  </div>
                  <div><pre class="highlight-p-cls" v-html="ruleForm.highlight.replace(/\u21B5/g, '<br/>')"></pre></div>
                </div>
              </el-row>
              <el-row v-if="ruleForm.description" type="flex" justify="center" style="margin-top:90px">
                <el-col :span="16">
                  <pre
                    v-drag
                    class="description-span-cls dragable-cls"
                    v-html="ruleForm.description.replace(/\u21B5/g, '<br/>')"
                  ></pre>
                </el-col>
              </el-row>
              <div
                v-if="ruleForm.headHunting.name && ruleForm.headHunting.qrcode"
                style="margin:90px 0px; text-align:center; padding-bottom: 90px;"
              >
                <span v-drag class="connect-title-cls dragable-cls">联系我们</span>
                <div style="text-align:center; margin-top: 50px;">
                  <div v-drag class="qrcode-container dragable-cls">
                    <img
                      v-if="ruleForm.headHunting.qrcode"
                      :src="ruleForm.headHunting.qrcode"
                      style="width: 318px; height:318px;margin-top: 22px;"
                    />
                  </div>
                </div>
                <div v-drag style="text-align:center; margin-top: 50px;" class="dragable-cls">
                  <span class="connect-detail-cls">长按图片扫描二维码</span> <br />
                  <span class="connect-detail-cls">直接添加专家顾问专业解答</span>
                </div>
              </div>
            </div>
            <div v-if="bgType === 'black&white'" id="picDiv" class="pic-temp-cls-option">
              <div>
                <el-row type="flex" align="middle" justify="start" style="width:100%; background:#ffffff">
                  <el-col :span="24" style="margin-bottom:20px;text-align:center;">
                    <span style="font-size:20px;">成功之路 始于热爱 源于分享</span>
                  </el-col>
                </el-row>
                <div v-if="ruleForm.location" v-drag class="dragable-cls align-left-cls margin-top-cls">
                  <span class="option-title-cls">{{ ruleForm.location }}</span>
                </div>
                <div class="option-main-body align-left-cls">
                  <div v-if="ruleForm.job" v-drag class="job-option dragable-cls">
                    <span class="option-title-cls">职位</span> <br />
                    <div class="job-option-detail-cls">{{ ruleForm.job }}</div>
                  </div>
                  <div v-if="ruleForm.company" v-drag class="company-option dragable-cls margin-bottom-cls">
                    <span class="option-title-cls">公司：</span>
                    <span class="option-detail-span-cls">{{ ruleForm.company }}</span>
                  </div>
                  <div v-if="ruleForm.experience" v-drag class="company-option dragable-cls margin-bottom-cls">
                    <span class="option-title-cls">工作年限要求：</span>
                    <span class="option-detail-span-cls">{{ ruleForm.experience }}</span>
                  </div>
                  <div
                    v-if="ruleForm.startDate && ruleForm.endDate"
                    v-drag
                    class="company-option dragable-cls margin-bottom-cls"
                  >
                    <span class="option-title-cls">招聘有效期：</span>
                    <span class="option-detail-span-cls"
                      >{{ ruleForm.startDate | formatdate }} - {{ ruleForm.endDate | formatdate }}</span
                    >
                  </div>
                  <div v-if="ruleForm.highlight" class="el-row is-justify-left el-row--flex" style="margin-top: 20px;">
                    <div v-drag class="job-option dragable-cls">
                      <span class="option-title-cls" style="border-bottom: 3px solid black;">职位亮点</span>
                      <div>
                        <pre class="highlight-option-cls" v-html="ruleForm.highlight.replace(/\u21B5/g, '<br/>')">
saasass</pre
                        >
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="ruleForm.description"
                    class="el-row is-justify-left el-row--flex"
                    style="margin-top: 90px;"
                  >
                    <div v-drag class="job-option dragable-cls">
                      <span class="option-title-cls" style="border-bottom: 3px solid black;">职位详情</span>
                      <div>
                        <pre
                          class="highlight-option-cls"
                          v-html="ruleForm.description.replace(/\u21B5/g, '<br/>')"
                        ></pre>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="ruleForm.headHunting.qrcode"
                    class="el-row is-justify-center el-row--flex"
                    style="margin: 90px 0px; padding-bottom: 90px;"
                  >
                    <div class="el-col el-col-12">
                      <span v-drag class="apply-bow-span dragable-cls">APPLY NOW &nbsp;&nbsp; &gt;</span>
                      <div
                        v-drag
                        class="dragable-cls"
                        style="text-align: center; margin-top: 150px; vertical-align: middle;"
                      >
                        <span class="connect-detail-option-cls">长按图片扫描二维码</span> <br />
                        <span class="connect-detail-option-cls">直接添加专家顾问专业解答</span>
                      </div>
                    </div>
                    <div v-drag class="dragable-cls el-col el-col-12" style="text-align: center; margin-top: 50px;">
                      <div class="qrcode-container" style="margin-left: 0px !important;">
                        <img
                          :src="ruleForm.headHunting.qrcode"
                          style="width: 318px; height: 318px; margin-top: 22px;"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-card>
    <el-dialog :visible.sync="editCodeVisible" :close-on-click-modal="false" :modal="false" width="400px">
      <el-row :gutter="20" class="mb10">
        <el-col :span="6">顾问</el-col>
        <el-col :span="18">{{ user.姓名 }}</el-col>
      </el-row>
      <el-row :gutter="20" class="mb10">
        <el-col :span="6">您的二维码</el-col>
        <el-col :span="18">
          <el-select v-model="qrcodeType" placeholder="请选择" size="mini">
            <el-option :label="'工作'" :value="'工作'"></el-option>
            <el-option :label="'个人'" :value="'个人'"></el-option>
            <el-option :label="'其他'" :value="'其他'"></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row>
        <img v-if="qrcodes[qrcodeType]" :src="qrcodes[qrcodeType]" class="avatar" />
        <el-upload
          v-else
          class="avatar-uploader"
          style="display:flex;justify-content:center"
          :action="uploadUrl"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          with-credentials
        >
          <el-button :src="qrcodes[qrcodeType]" class="avatar" icon="el-icon-plus"></el-button>
        </el-upload>
      </el-row>
      <el-row type="flex" align="center" justify="center">
        <el-upload
          class="avatar-uploader"
          style="margin-right:50px;"
          :action="uploadUrl"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          with-credentials
        >
          <el-button type="text">上传</el-button>
        </el-upload>
        <el-button type="text" @click="del">删除</el-button>
      </el-row>
      <el-row type="flex" align="center" justify="center">
        <el-button type="info" plain style="margin-right:50px;" size="mini" @click="editCodeVisible = false"
          >取消</el-button
        >
        <el-button type="primary" size="mini" @click="upload">保存</el-button>
      </el-row>
    </el-dialog>
    <el-dialog :visible.sync="previewVisible" :close-on-click-modal="false" :append-to-body="true" width="500px">
      <div v-loading="previewLodaing"><img :src="previewImgSrc" alt class="preview-img" /></div>
      <el-button type="primary" style="display:block;margin:20px auto 0" size="mini" @click="generateImg('ruleForm')"
        >导出图片并存为项目附件</el-button
      >
    </el-dialog>
  </el-dialog>
</template>
<script>
import html2canvas from 'html2canvas'
import querystring from 'querystring'
import url from 'url'
import { HeadHuntings } from './headhuntings'

const dateFormat = require('dateformat')

const platform = {
  A: '大平台',
  B: '中型平台',
  C: '小平台',
}
export default {
  //   computed:{
  //       url: function(){
  //           let encodedUrl=window.location.href+'?company='+encodeURIComponent(this.ruleForm.company)+'&job='+encodeURIComponent(this.ruleForm.job)+'&location='+encodeURIComponent(this.ruleForm.location)+'&experience='+encodeURIComponent(this.ruleForm.experience)+'&startDate='+encodeURIComponent(new Date(this.ruleForm.startDate).toDateString())+'&endDate='+encodeURIComponent(new Date(this.ruleForm.endDate).toDateString())+'&highlight='+encodeURIComponent(this.ruleForm.highlight)+'&description='+encodeURIComponent(this.ruleForm.description);
  //           console.log(encodedUrl);
  //           return encodedUrl;
  //       }
  //   },
  filters: {
    formatdate: function(date) {
      const createdDate = new Date(date)
      if (!date) {
        return
      }
      return `${createdDate.getFullYear()}年${createdDate.getMonth() + 1}月${createdDate.getDate()}日 `
    },
  },
  data() {
    return {
      ruleForm: {
        company: '',
        job: '',
        location: '',
        startDate: '',
        endDate: '',
        experience: '',
        highlight: '',
        description: '',
        headHunting: {},
      },
      rules: {
        company: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
          { min: 3, max: 40, message: '长度在 3 到 40 个字符', trigger: 'blur' },
        ],
        job: [
          { required: true, message: '请输入职位名称', trigger: 'blur' },
          { min: 3, max: 40, message: '长度在 3 到 40 个字符', trigger: 'blur' },
        ],
        location: [
          { required: true, message: '请输入工作地点', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' },
        ],
        experience: [{ required: true, message: '请输入工作经验要求', trigger: 'blur' }],
        highlight: [{ required: true, message: '必填项', trigger: 'blur' }],
        description: [{ required: true, message: '必填项', trigger: 'blur' }],
      },
      _id: '',
      value: [],
      options: [],
      HeadHuntings: HeadHuntings,
      qrcodeType: '工作',
      visible: false,
      bgType: '',
      dataRange: [],
      user: app.user,
      editCodeVisible: false,
      previewVisible: false,
      previewLodaing: false,
      previewImgSrc: '',
      qrcodes: Object.assign({ 工作: '', 个人: '', 其他: '' }, app.user.qrcodes),
      uploadUrl: `${window.host}/publicUploads`,
      bgType: 'default',
      tempProject: {
        平台: [],
        目标行业: [],
        项目名称: '',
        办公地: [],
        职位详情: '',
        岗位要求: '',
        岗位职责: '',
        工作年限: ['', ''],
        职位亮点及优势: '',
      },
      //   background: require('../../statistics/images/background.png')
    }
  },
  created() {},
  mounted() {},
  methods: {
    async getProject(id) {
      try {
        const data = await window.app.service('project').fetch(id)
        this.tempProject = Object.assign(this.tempProject, data)
      } catch (error) {
        this.$message.error(`projectDetail getProject:${error.message}`)
      }
    },
    async open(project) {
      await this.getProject(project._id)
      project = this.tempProject
      const formatUsers = app.accountWithQRCode.filter(val => val.value !== app.user.account)
      formatUsers.unshift(app.accountWithQRCode.find(val => val.value === app.user.account))
      this.options = formatUsers
      this._id = project._id
      this.ruleForm.company = `某${platform[project.平台[0]] || ''}${project.目标行业[0] || ''}${project.项目名称 ||
        ''}`
      this.ruleForm.job = project.项目名称 || ''
      this.ruleForm.location = project.办公地.join(',')
      this.ruleForm.description = project.职位详情 || (project.岗位要求 || '') + (project.岗位职责 || '')
      this.ruleForm.experience = project.工作年限.every(val => val !== '') ? project.工作年限.join('-') : ''
      this.ruleForm.highlight = project.职位亮点及优势 || ''
      this.visible = true
      this.value = [
        app.user.account,
        app.user.qrcodes ? app.user.qrcodes.工作 || app.user.qrcodes.个人 || app.user.qrcodes.其他 : '',
      ]
      this.handleChange(this.value)
      this.project = project
    },
    closeDialog() {
      if (
        this.ruleForm.highlight === (this.project.职位亮点及优势 || '') &&
        (this.ruleForm.description === (this.project.岗位要求 || '') + (this.project.岗位职责 || '') ||
          this.ruleForm.description === (this.project.职位详情 || ''))
      ) {
        this.visible = false
        return
      }
      this.$confirm('关闭后当前新填写信息不会保存,是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '再想想',
        type: 'warning',
        center: true,
      })
        .then(() => {
          this.visible = false
        })
        .catch(() => {})
    },
    handleChange(value) {
      this.ruleForm.headHunting.name = value[0]
      this.ruleForm.headHunting.qrcode = value[1]
    },
    generateImg(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          html2canvas(document.getElementById('picDiv'), { useCORS: true }).then(async canvas => {
            //   document.body.appendChild(canvas);
            const dataUrl = canvas.toDataURL()
            const eleLink = document.createElement('a')
            eleLink.download = `${dateFormat(new Date(), 'yyyymmdd')}${this.ruleForm.job}${new Date().getTime()}.png`
            eleLink.href = dataUrl
            eleLink.style.display = 'none'
            // 触发点击
            document.body.appendChild(eleLink)
            eleLink.click()
            // 然后移除
            document.body.removeChild(eleLink)
            try {
              await app.service('project').modify({
                id: this._id,
                param: {
                  职位亮点及优势: this.ruleForm.highlight,
                  职位详情: this.ruleForm.description,
                  工作年限:
                    this.ruleForm.experience.indexOf('-') !== -1
                      ? this.ruleForm.experience.split('-')
                      : [this.ruleForm.experience, ''],
                },
              })
              this.project.职位亮点及优势 = this.ruleForm.highlight
              this.project.职位详情 = this.ruleForm.description
              this.project.工作年限 =
                this.ruleForm.experience.indexOf('-') !== -1
                  ? this.ruleForm.experience.split('-')
                  : [this.ruleForm.experience, '']
              this.$message.success('同步至项目成功')
            } catch (e) {
              this.$message.error(e)
            }
            this.$confirm('是否要将当前图片作为附件保存到项目?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '不用了',
              type: 'warning',
              center: true,
            })
              .then(() => {
                this.upsertAttachment(dataUrl)
              })
              .catch(() => {})
          })
        } else {
          this.$message.error('请确认必填项是否完整！')
          return false
        }
      })
    },
    async upsertAttachment(dataUrl) {
      try {
        const loading = this.$loading({
          lock: true,
          text: '图片正在挂载到项目,请稍后',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        const { data } = await this.$axios.post(`${window.host}/bufferUploads`, {
          filename: `${dateFormat(new Date(), 'yyyymmdd')}${this.ruleForm.job}${new Date().getTime()}.png`,
          encoding: 'base64',
          buffer: dataUrl.slice(22), // base64 数据去掉前缀
          uploader: this.user.account,
          type: '其他',
        })
        const parse = Object.assign(data[0], { id: this.project._id, idField: 'projectId' })
        const res = await app.service('project').upsertAttachmentFromOss(parse)
        loading.close()
        this.$message.success('图片挂载至项目附件成功!')
      } catch (error) {
        this.$message.error(error)
      }
    },
    async setHighigth() {
      if (!this.ruleForm.highlight) {
        this.$message.error('禁止为空!')
        return
      }
      this.$confirm('是否将信息同步至项目信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '再想想',
        type: 'warning',
        center: true,
      })
        .then(async () => {
          try {
            await app.service('project').modify({
              id: this._id,
              param: {
                职位亮点及优势: this.ruleForm.highlight,
              },
            })
            this.$message.success('同步成功!')
          } catch (e) {
            this.$message.error(e)
          }
        })
        .catch(() => {})
    },
    previewImg(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.previewVisible = true
          this.previewLodaing = true
          html2canvas(document.getElementById('picDiv'), { useCORS: true }).then(canvas => {
            this.previewImgSrc = canvas.toDataURL()
            this.previewLodaing = false
          })
        } else {
          this.$message.error('请确认必填项是否完整！')
          return false
        }
      })
    },
    resetForm(ruleForm) {
      this.$confirm('是否要将当前消息恢复至默认', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '再想想',
        type: 'warning',
        center: true,
      })
        .then(() => {
          this.open(this.project)
        })
        .catch(() => {})
    },
    handleCommand: function(command) {
      this.ruleForm.headHunting = command
    },
    async handleAvatarSuccess(res, file) {
      const tempObj = {}
      tempObj[this.qrcodeType] = `https://alphahr.oss-cn-beijing.aliyuncs.com/documents/upload/${res[0].md5}.${
        res[0].originalname
      }`
      this.qrcodes = Object.assign(this.qrcodes, tempObj)
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    async upload() {
      const res = await app.service('project').updateQrcodes({ id: this.user._id, param: { qrcodes: this.qrcodes } })
      if (res.status === 'success') {
        this.$message.success('保存成功!')
        await app.getUsers()
        const formatUsers = app.accountWithQRCode.filter(val => val.value !== app.user.account)
        formatUsers.unshift(app.accountWithQRCode.find(val => val.value === app.user.account))
        this.options = formatUsers
        this.editCodeVisible = false
      } else {
        this.$message.error('保存失败')
      }
    },
    del() {
      const tempObj = {}
      tempObj[this.qrcodeType] = ''
      this.qrcodes = Object.assign(this.qrcodes, tempObj)
    },
  },
}
</script>
<style>
.mb20 {
  margin-bottom: 20px;
}
.mr20 {
  margin-right: 20px;
}
.mb10 {
  margin-bottom: 10px;
}
.dragable-cls {
  position: relative;
}
.pic-temp-cls {
  background: url(../../statistics/images/background.png) no-repeat;
  width: 900px;
  font-family: 'STYuanti-SC-Regular';
  /* height:1280px; */
}
.project-pic .el-header {
  background-color: #409eff;
  color: #ffffff;
  text-align: center;
  line-height: 60px;
  font-size: 2em;
}
.project-pic .el-textarea {
  display: inline-block;
  width: 100%;
  vertical-align: bottom;
  font-size: 14px;
  border: 1px solid #c0c4cc;
}
.detail-span-cls {
  font-size: 24px;
  color: #ffffff;
  white-space: pre;
}
.yellow-span-cls {
  font-size: 24px;
  color: #ff8633;
}
.title-cls {
  font-size: 64px;
  letter-spacing: 0.93px;
  text-align: center;
  color: #ffffff;
  padding: 0 30px;
  margin-top: 60px;
  padding-top: 60px;
}
.highlight-area-cls {
  background: url(../../statistics/images/shape.png) no-repeat, #c5c4cf;
  width: 700px;
  padding: 0;
  margin: 0;
  border-radius: 30px;
}
.highlight-p-cls {
  font-family: 'STYuanti-SC-Regular';
  padding: 20px 40px;
  font-size: 32px;
  color: #000000;
  white-space: pre-wrap;
  word-wrap: break-word;
}
.description-span-cls {
  font-family: 'STYuanti-SC-Regular';
  font-size: 29px;
  color: #ffffff;
  letter-spacing: 0.42px;
  white-space: pre-wrap;
  word-wrap: break-word;
}
.connect-title-cls {
  font-size: 48px;
  color: #ffffff;
  letter-spacing: 0.7px;
}
.connect-detail-cls {
  font-family: STYuanti-SC-Regular;
  font-size: 36px;
  color: #ffffff;
  letter-spacing: 0.53px;
  text-align: center;
}
.qrcode-container {
  width: 366px;
  height: 366px;
  background: #ffffff;
  border-radius: 40px;
  text-align: center;
  vertical-align: middle;
  margin-left: 280px;
}
.avatar-uploader .el-upload {
  display: inline-flex;
  cursor: pointer;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
  margin: 20px auto;
}
.preview-img {
  width: 400px;
  margin: 0 auto;
  display: block;
}
#picDiv {
  margin: 0 auto;
}
.option-title-cls {
  color: #000;
  font-family: STYuanti-SC-Regular;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 10px;
}
.job-option-detail-cls {
  color: #000;
  font-size: 50px;
  font-weight: bolder;
  margin-top: 20px;
  margin-bottom: 20px;
  padding-bottom: 5px;
  border-bottom: 3px solid #000;
}
.option-detail-span-cls {
  font-size: 22px;
  margin-bottom: 10px;
}
.highlight-option-cls {
  font-family: STYuanti-SC-Regular;
  font-size: 20px;
  color: #524f4f;
  white-space: pre-wrap;
  word-wrap: break-word;
}
.apply-bow-span {
  padding: 10px;
  color: #fff;
  font-size: 24px;
  background: linear-gradient(90deg, #7e1515, #030368);
}
.connect-detail-cls,
.connect-detail-option-cls {
  font-family: STYuanti-SC-Regular;
  letter-spacing: 0.53px;
  text-align: center;
}
.option-main-body {
  margin-top: 50px;
  margin-left: 150px;
  margin-right: 100px;
  padding-left: 20px;
  padding-right: 20px;
}
.align-left-cls {
  text-align: left;
  padding-left: 50px;
  margin-left: 50px;
  margin-top: 50px;
}
.connect-detail-option-cls {
  font-size: 24px;
  color: #000;
}
</style>
